import React from "react";
import { Shield, Target, HeartHandshake } from "lucide-react";
import { useI18n } from "@/i18n";

export default function About() {
  const { t } = useI18n();
  const values = [
    { icon: Shield, t: "about.value1.t", d: "about.value1.d" },
    { icon: Target, t: "about.value2.t", d: "about.value2.d" },
    { icon: HeartHandshake, t: "about.value3.t", d: "about.value3.d" },
  ];

  return (
    <div data-testid="page-about" className="max-w-5xl mx-auto px-6 lg:px-10 pt-16 pb-24">
      <div className="mb-24">
        <div className="text-[10px] tracking-[0.22em] uppercase text-stone-500 font-mono">{t("about.eyebrow")}</div>
        <h1 className="mt-4 font-serif text-5xl md:text-7xl tracking-tight text-stone-900 leading-[0.98] max-w-3xl">{t("about.title")}</h1>
        <div className="mt-10 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-1 hidden md:block">
            <span className="block w-10 h-px bg-[#B95736] mt-3"></span>
          </div>
          <div className="md:col-span-11 space-y-5 max-w-3xl">
            <p className="text-lg md:text-xl text-stone-700 leading-relaxed">{t("about.p1")}</p>
            <p className="text-lg md:text-xl text-stone-700 leading-relaxed">{t("about.p2")}</p>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {values.map((v, i) => {
          const Icon = v.icon;
          return (
            <div key={i} data-testid={`about-value-${i}`} className="p-8 rounded-lg border border-stone-200 bg-white">
              <div className="w-11 h-11 rounded-md bg-[#B95736]/10 flex items-center justify-center text-[#B95736]">
                <Icon size={20} strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 font-serif text-2xl text-stone-900">{t(v.t)}</h3>
              <p className="mt-2 text-stone-600 leading-relaxed">{t(v.d)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
